import {
  LOGIN_PARTICIPANT_USER,
  LOGIN_PARTICIPANT_SUCCESS,
  LOGOUT_PARTICIPANT_USER,
  LOGOUT_PARTICIPANT_USER_SUCCESS,
  PARTICIPANT_LOGIN_ERROR,
  SOCIAL_LOGIN,
} from "./actionTypes"

export const loginParticipantUser = (user, type, callback) => {
  return {
    type: LOGIN_PARTICIPANT_USER,
    payload: { user, type, callback },
  }
}

export const loginParticipantSuccess = user => {
  return {
    type: LOGIN_PARTICIPANT_SUCCESS,
    payload: user,
  }
}

export const logoutParticipantUser = history => {
  return {
    type: LOGOUT_PARTICIPANT_USER,
    payload: { history },
  }
}

export const logoutParticipantUserSuccess = () => {
  return {
    type: LOGOUT_PARTICIPANT_USER_SUCCESS,
    payload: {},
  }
}

export const participantLoginError = error => {
  return {
    type: PARTICIPANT_LOGIN_ERROR,
    payload: error,
  }
}
